import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateAdminConversationCategory } from '@entities/AdminConversationCategory/api/handlers/updateAdminConversationCategoryt';

export function useUpdateAdminConversationCategory() {
    const qc = useQueryClient();

    return useMutation({
        mutationFn: updateAdminConversationCategory,
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['adminConversationCategories'] });
        },
    });
}
